import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "thumb_up",
  "use": "thumb_up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"thumb_up\"><path d=\"M19.4 7H15V3.6L13.4 2H9.6L8 3.6v3L6.6 8H2v10.4L3.6 20h3l2 2h9.8l3.6-3.6V9.6L19.4 7zM6 18H4.4l-.4-.4V10h2v8zm14-6h-5v1h5v3h-5v1h5v.6L17.6 20H9.4L8 18.6V9.4l2-2v-3l.4-.4h2.2l.4.4V9h5.6l1.4 1.4V12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol